import { create as actualCreate, type StateCreator } from 'zustand';

const storeResetFns = new Set<() => void>();

const PERSISTED_STORAGE_KEYS = ['organizations-storage'];

export const resetAllStores = () => {
  storeResetFns.forEach((resetFn) => {
    resetFn();
  });

  PERSISTED_STORAGE_KEYS.forEach((key) => {
    sessionStorage.removeItem(key);
  });
};

export const create = (<T>() => {
  return (stateCreator: StateCreator<T>) => {
    const store = actualCreate(stateCreator);
    storeResetFns.add(() => {
      store.setState(store.getInitialState(), true);
    });
    return store;
  };
}) as typeof actualCreate;
